import { useSyncExternalStore } from 'react';

export type Route =
  | { name: 'home' }
  | { name: 'lesson'; id: string }
  | { name: 'sandbox' }
  | { name: 'glossary' }
  | { name: 'not-found'; path: string };

export function parseRoute(pathname: string): Route {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/') return { name: 'home' };
  const lesson = /^\/lesson\/([a-z0-9-]+)$/.exec(path);
  if (lesson) return { name: 'lesson', id: lesson[1] };
  if (path === '/sandbox') return { name: 'sandbox' };
  if (path === '/glossary') return { name: 'glossary' };
  return { name: 'not-found', path };
}

const listeners = new Set<() => void>();
const notify = () => listeners.forEach((l) => l());

if (typeof window !== 'undefined') window.addEventListener('popstate', notify);

export function navigate(to: string, opts: { replace?: boolean } = {}) {
  if (window.location.pathname + window.location.hash === to) return;
  if (opts.replace) window.history.replaceState(null, '', to);
  else window.history.pushState(null, '', to);
  notify();
  const hash = to.split('#')[1];
  if (!hash) {
    window.scrollTo?.(0, 0);
    // Desktop split / mobile tabs: content scrolls in `.pane`, not the window.
    document.querySelectorAll('.pane').forEach((el) => {
      (el as HTMLElement).scrollTop = 0;
    });
  }
}

export function useRoute(): Route {
  const pathname = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => window.location.pathname,
  );
  return parseRoute(pathname);
}

export const lessonPath = (id: string, section?: string) => `/lesson/${id}${section ? `#${section}` : ''}`;
